import { CodeDescription } from "./code-description-dto";

export class Ethnicity {
    getEthnicityListing(): CodeDescription[] {
        return [
            { "Code": "Hispanic or Latino", "Description": "Hispanic or Latino" },
            { "Code": "Not Hispanic or Latino", "Description": "Not Hispanic or Latino" },
            { "Code": "U", "Description": "Unspecified" }
        ]
    }
}